/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'horn': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M702.368 670.4c40.544-40.544 65.6-96.544 65.6-158.4s-25.056-117.856-65.6-158.4a32 32 0 0145.248-45.248C799.744 360.48 831.968 432.48 831.968 512s-32.224 151.52-84.352 203.648a32 32 0 01-45.248-45.248zM815.52 783.52C884.992 714.048 928 618.048 928 512s-42.976-202.016-112.48-271.52a32 32 0 0145.248-45.248c81.056 81.056 131.2 193.056 131.2 316.768s-50.144 235.712-131.2 316.768a32 32 0 01-45.248-45.248zM312.256 352H112.032a16 16 0 00-16 16v288a16 16 0 0016 16h200.224a95.88 95.88 0 0167.872 28.128L544 864V160.032L380.128 323.904a95.36 95.36 0 01-67.744 28.128h-.128zm41.344-92.096l145.12-145.12c40.32-40.32 109.248-11.776 109.248 45.248V864c0 57.024-68.928 85.568-109.248 45.248L353.6 764.128A95.36 95.36 0 00285.856 736H96a64 64 0 01-64-64V352a64 64 0 0164-64h189.856a95.36 95.36 0 0067.744-28.128z"/>'
  }
})
